var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.291,
    height: 36.291,
    viewBox: "0 0 36.291 36.291",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f7db83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d45455"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "angry",
    transform: "translate(-4755.587 -2167.377)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 18.145,
    cy: 18.145,
    r: 18.145,
    transform: "translate(4755.587 2167.377)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_144",
    "data-name": "Path 144",
    d: "M4779.564,2190.758a1.886,1.886,0,1,0,1.851-2.246A2.078,2.078,0,0,0,4779.564,2190.758Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_145",
    "data-name": "Path 145",
    d: "M4775.985,2189.828a.712.712,0,0,1-.037-1.423c5.037-.271,9.8-1.172,10.194-1.93a.686.686,0,0,1,.708-.685.733.733,0,0,1,.707.741c0,2.214-6.272,3.015-11.533,3.3Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_146",
    "data-name": "Path 146",
    d: "M4767.536,2190.758a1.886,1.886,0,1,1-1.851-2.246A2.078,2.078,0,0,1,4767.536,2190.758Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M4771.116,2189.828h-.039c-5.262-.282-11.534-1.083-11.534-3.3a.712.712,0,1,1,1.425,0c.383.7,5.147,1.6,10.185,1.874a.712.712,0,0,1-.037,1.423Z",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M4778.016,2197.957a.723.723,0,0,1-.194-.027,18.581,18.581,0,0,0-8.754,0,.712.712,0,0,1-.378-1.374,19.69,19.69,0,0,1,9.521,0,.712.712,0,0,1-.195,1.4Z",
    fill: "#3c3c3b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry);
export default __webpack_public_path__ + "static/media/angry.1c7e0652d0a9d99e5d15603858028e34.svg";
export { ForwardRef as ReactComponent };